"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bell = void 0;
var react_1 = __importDefault(require("react"));
var constants_1 = require("../constants");
var colors_1 = require("../../colors");
var Bell = function (_a) {
    var color = _a.color, height = _a.height, size = _a.size, width = _a.width;
    return (react_1.default.createElement("svg", { width: width || size || constants_1.DEFAULT_ICON_SIZE, height: height || size || constants_1.DEFAULT_ICON_SIZE, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react_1.default.createElement("path", { d: 'M11.9996 20.9999C13.0996 20.9999 13.9996 20.0999 13.9996 18.9999H9.99956C9.99956 20.0999 10.8896 20.9999 11.9996 20.9999ZM17.9996 14.9999V9.99986C17.9996 6.92986 16.3596 4.35986 13.4996 3.67986C12.337 3.40353 11.5 3.49991 10.4996 3.67986C7.62956 4.35986 5.99956 6.91986 5.99956 9.99986V14.9999L4.70956 16.2899C4.07956 16.9199 4.51956 17.9999 5.40956 17.9999H18.5796C19.4696 17.9999 19.9196 16.9199 19.2896 16.2899L17.9996 14.9999Z', fill: color ? (0, colors_1.getColor)(color) : 'currentColor' })));
};
exports.Bell = Bell;
